const mEditionAssetContentsTreeNodeActivation = {
  mEditionAssetContentsTreeNodeActivation: {
    messages: {
      daysAfter: 'Días despúes',
      inmediate: 'Inmediato',
      notActivated: 'No Activado'
    }
  }
}

export default mEditionAssetContentsTreeNodeActivation
